import { ref } from 'vue'

/* ================================================================
   판매관리센터 공통 UI 상태.
   주문·상품 데이터는 API를 쓰고, 여기에는 셸 토스트만 둔다.
   ================================================================ */

const toast = ref('')
let toastTimer = 0

export function useSellerData() {
  const notify = (message: string) => {
    toast.value = message
    window.clearTimeout(toastTimer)
    toastTimer = window.setTimeout(() => {
      toast.value = ''
    }, 2400)
  }

  return {
    toast,
    notify,
  }
}
